import React from 'react';

import { DataCell, Heading, InfoColCell, InfoRowCell, Table, Whitespace, WindPanel } from './HarbourDial.style';
import SpeedDial from './SpeedDial';
import getObsData from './utils/getObsData';

interface WindSpeedPanelProps {
    data: ReturnType<typeof getObsData>;
    runwayAngle: number;
}

const WindSpeedPanel: React.FC<WindSpeedPanelProps> = ({ data, runwayAngle }) => (
    <WindPanel>
        <Heading>Wind speed (kt)</Heading>

        <SpeedDial speed={data.PT1M.windSpeed.avg} minSpeed={data.PT1M.windSpeed.min} maxSpeed={data.PT1M.windSpeed.max} />

        {typeof runwayAngle === 'number' && <Whitespace />}

        <Table>
            <tbody>
                <tr>
                    <td />
                    <InfoColCell>1min</InfoColCell>
                    <InfoColCell>10min</InfoColCell>
                    <InfoColCell>60min</InfoColCell>
                </tr>
                <tr>
                    <InfoRowCell>Avg</InfoRowCell>
                    <DataCell>{data.PT1M.windSpeed.avg}</DataCell>
                    <DataCell>{data.PT10M.windSpeed.avg}</DataCell>
                    <DataCell>{data.PT1H.windSpeed.avg}</DataCell>
                </tr>
                <tr>
                    <InfoRowCell>Gust</InfoRowCell>
                    <DataCell>{data.PT1M.windSpeed.max}</DataCell>
                    <DataCell>{data.PT10M.windSpeed.max}</DataCell>
                    <DataCell>{data.PT1H.windSpeed.max}</DataCell>
                </tr>
                <tr>
                    <InfoRowCell>Lull</InfoRowCell>
                    <DataCell>{data.PT1M.windSpeed.min}</DataCell>
                    <DataCell>{data.PT10M.windSpeed.min}</DataCell>
                    <DataCell>{data.PT1H.windSpeed.min}</DataCell>
                </tr>
            </tbody>
        </Table>
    </WindPanel>
);

export default WindSpeedPanel;
